import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    repayLoading: {
        id: '_.processing_payment.modal.early_repayment.loading',
        defaultMessage:
            '{amount} is being repaid by your debit card ending {paymentMethod}...'
    },
    drawDownLoading: {
        id: '_.processing_payment.modal.draw_down.loading',
        defaultMessage: `We're sending {amount} to your bank account...`
    },
    truelayerRepayLoading: {
        id: '_.processing_payment.modal.early_repayment_truelayer.loading',
        defaultMessage:
            'You are being redirected to Truelayer to complete the payment'
    }
});
